import logo from './logo.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom'
import { lazy ,Suspense} from 'react';

const Project = lazy(() => import('./Project.js'));
const Main = lazy(() => import('./Main.js'));
const Company = lazy(() => import('./Company.js'));
const Contact = lazy(() => import('./Contact.js'));
const Personalinfo = lazy(() => import('./Personalinfo.js'));

function App() {
  let Navigate = useNavigate();
  return (
    <div className="App">
      <div className="Nav-bar">
        <img src={logo} alt="Company Logo" className="Logo" 
        onClick={() => {Navigate('/')}}/>
        <div className="Nav-items">
         <p onClick={() => {Navigate('/ProjectFBbath')}}>시공 사례</p>
         <p onClick={() => {Navigate('/ContactFBbath')}}>견적 문의</p>
         
        <p onClick={() => {Navigate('/CompanyFBbath')}}>회사 정보</p>
        </div>
      </div>
      <Suspense>
      <Routes>
        <Route path='/' element={
          <Main />
        }>
        </Route>
        <Route path='/CompanyFBbath' element= { <Company/>}> 
        </Route>
        <Route path='/ProjectFBbath' element={<Project/>}> 
        </Route>
        <Route path='/ContactFBbath' element={<Contact/>}>
        </Route>
        <Route path="/Personalinfo" element={<Personalinfo />}>
        </Route>


      </Routes>
      </Suspense>

    </div>
  );
}

export default App;
